<script setup lang="ts">
import type { TextFieldProps } from '@formwerk/core'
import { useFormContext, useTextField } from '@formwerk/core'

const props = defineProps<TextFieldProps>()

const { inputProps, labelProps, errorMessage, errorMessageProps, fieldValue, isBlurred }
  = useTextField(props)

const isDirty = computed(() => fieldValue.value?.length > 0)
// Inside a form, errors only show after a submit attempt, then update live as the user fixes them
const form = useFormContext()
const errored = computed(() => (form ? form.isSubmitAttempted.value : isBlurred.value) && errorMessage.value)
</script>

<template>
  <div class="input">
    <div class="w-full relative" :class="{ 'c-red': errored }">
      <input
        v-bind="inputProps"
        placeholder=" "
        class="peer typo-sans-1 c-current leading-5 pb-0.75 pt-3 appearance-none border-b border-current h-9 w-full block uppercase"
      >

      <label
        v-bind="labelProps"
        class="typo-sans-1 leading-5 motion-snug pointer-events-none select-none uppercase left-0 top-3 absolute peer-focus:scale-80 peer-focus:-translate-x-10% peer-focus:-translate-y-4"
        :class="{
          '-translate-y-4 scale-80 -translate-x-10%': isDirty,
        }"
      >
        {{ label }}
      </label>
    </div>
    <TransitionDefault>
      <p
        v-if="errored"
        v-bind="errorMessageProps"
        class="text-red-500 typo-sans-1 mt-1"
      >
        {{ errorMessage }}
      </p>
    </TransitionDefault>
  </div>
</template>
